import styled from "styled-components";
import { breakpoint } from "@utilities";
import { AppModuleLayout } from "@layouts";

export const Discounts = () => {
    return (
        <AppModuleLayout>
            <StyledDiscount>
                <div className="discountWrapper">
                    <div className="discountContent">
                        <h2 className="heading">Learn More About Your Order Discount</h2>
                        <br />
                        <br />
                        <div className="discountSection">
                            <h3 className="subSectionHeading">What Is the Order-Level Discount?</h3>
                            <p className="contentText">
                                We're offering a special discount on your entire order.
                                <br />
                                The order-level discount is a feature that applies a discount to
                                your order at checkout when certain conditions are met. It applies
                                to the entire order, not just individual items, and is designed to
                                offer you the best possible value—without requiring any extra steps.
                                <br />
                                This discount helps you save more when your cart includes eligible
                                items. The more qualifying value in your cart, the better your
                                chance of receiving a full or partial discount.
                                <br />
                                You’ll see the discounted price reflected directly on the cart,
                                quote, and checkout screens—so you’ll always know how much you're
                                saving before you place your order.
                            </p>
                        </div>
                        <div className="discountSection">
                            <h3 className="subSectionHeading">
                                How Do I Qualify for the Discount?
                            </h3>
                            <p className="contentText">
                                To receive the discount:
                                <br />
                                A valid discount offer must be active in the app.
                                <br />
                                Your cart or quote must include items that meet the required
                                eligibility criteria.
                                <br />
                                When your order meets the necessary conditions, the full discount is
                                applied. If it doesn’t fully qualify, we’ll still apply as much of
                                the discount as possible.
                            </p>
                        </div>
                        <div className="discountSection">
                            <h3 className="subSectionHeading">How Is the Discount Calculated?</h3>
                            <p className="contentText">
                                We apply discounts based on the overall value of the items in your
                                cart:
                                <br />
                                Full Discount: If your cart qualifies, the full discount is applied
                                at checkout.
                                <br />
                                Partial Discount: If your cart doesn’t fully qualify, a reduced
                                discount may still be available—so you can still enjoy savings.
                                <br />
                                Our system ensures discounts are applied fairly and consistently,
                                giving you the best available value.
                            </p>
                        </div>
                        <div className="discountSection">
                            <h3 className="subSectionHeading">
                                Will I See the Discount Before Checkout?
                            </h3>
                            <p className="contentText">
                                Yes. If a discount is applied:
                                <br />
                                You’ll see the updated prices and discounted amounts in the cart,
                                quote, and checkout screens.
                                <br />A helpful question mark (?) icon near the discount field will
                                provide additional details.
                            </p>
                        </div>
                        <div className="discountSection">
                            <h3 className="subSectionHeading">What Happens If I Change My Cart?</h3>
                            <p className="contentText">
                                If you add, remove, or update item quantities, your discount will
                                automatically update to reflect the new order total.
                            </p>
                        </div>
                        <div className="discountSection">
                            <h3 className="subSectionHeading">
                                What If the Discount Changes After I Add Items?
                            </h3>
                            <p className="contentText">
                                If the discount offer changes while your cart is still active, your
                                prices and discount will automatically update to reflect the latest
                                available offer—ensuring you always get the best available discount.
                            </p>
                        </div>
                        <div className="discountSection">
                            <h3 className="subSectionHeading">Need to Know</h3>
                            <p className="contentText">
                                Discounts apply only when eligibility criteria are met.
                                <br />
                                Orders that don’t meet the required conditions will not receive a
                                discount.
                                <br />
                                If your order includes multiple quotes, each quote is evaluated
                                independently for discount eligibility.
                            </p>
                        </div>
                        <div className="discountSection">
                            <h3 className="subSectionHeading">Pro Tip</h3>
                            <p className="contentText">
                                Always check the cart summary and the discount section at checkout
                                to stay informed about your current savings.
                            </p>
                        </div>
                    </div>
                </div>
            </StyledDiscount>
        </AppModuleLayout>
    );
};

const StyledDiscount = styled.div`
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    height: calc(100vh - 164px);
    width: 100%;
    padding: 24px;
    box-sizing: border-box;
    background: #fff;

    .discountWrapper {
        display: flex;
        flex-direction: column;
        flex: 1;
        overflow: auto;
        max-width: 1200px;
        width: 100%;
        padding: 0px 24px;
        padding-bottom: 50px;
    }
    .discountSection {
        margin-top: 20px;
    }

    .discountContent {
        width: 100%;
        max-width: 1200px;
    }

    .heading {
        font-size: 24px;
        font-weight: 600;
        line-height: 120%;
        color: ${(props) => props.theme.colors.black};
        margin: 0;
        text-align: left;
    }

    .subSectionHeading {
        font-size: 18px;
        font-weight: 600;
        line-height: 120%;
        color: #131214;
        margin: 16px 0 8px 0;
    }

    .contentText {
        margin: 0 0 16px 0;
    }

    ${breakpoint.breakMobileMedium`
        .discountContent {
            padding: 24px;
            font-size: 16px;
            font-weight: 400;

            &::-webkit-scrollbar {
                width: 5px;
            }

            &::-webkit-scrollbar-thumb {
                background-color: rgba(0, 0, 0, .3);
                border-radius: 5px;
            }
        }
    `}

    @media (max-width: ${(p) => p.theme.breakPoints.breakMobile}) {
        .heading {
            font-size: 24px;
        }
        .subHeading,
        .discountContent,
        .subSectionHeading {
            font-size: 16px;
        }
    }
`;
